import React from "react";
import styled from "styled-components";
import { Stack, Button, Card, Row, Col } from "react-bootstrap";

const SuccessTitle = styled("h3")`
  line-height: 1.5;
  font-weight: 600;
  font-family: ${(props) => props.theme.fontPrimary}, Arial, sans-serif;
  color: ${(props) => props.theme.colors.success};
`;

const TitleContainer = styled("div")`
  text-align: center;
`;

const CheckIconSection = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors.success};
`;

export interface ExitoOption {
  path: string;
  variant: "primary" | "secondary" | "success";
  description: string;
  isLast?: boolean;
}

function ExitoCard({
  title,
  options,
}: {
  title: string;
  options: ExitoOption[];
}) {
  return (
    <Card>
      <Card.Body>
        <Row className="justify-content-center">
          <Stack gap={3} className="col col-9">
            <CheckIconSection>
              <i className="fa fa-check-circle fa-5x" aria-hidden="true"></i>
            </CheckIconSection>
            <TitleContainer className="w-100">
              <SuccessTitle>{title}</SuccessTitle>
            </TitleContainer>
            <Row className="d-flex justify-content-center">
              <Col className="col-5">
                {options.map((opcion, i) => {
                  return (
                    <Row className={opcion.isLast ? "mb-5" : "mb-2"} key={i}>
                      <Button variant={opcion.variant} href={opcion.path}>
                        {opcion.description}
                      </Button>
                    </Row>
                  );
                })}
              </Col>
            </Row>
          </Stack>
        </Row>
      </Card.Body>
    </Card>
  );
}
export default ExitoCard;
